// extracted by mini-css-extract-plugin
export default {"row":"PartnerOrganizationSelector_row__yM9H3"};